import "jspdf-autotable";
import axios from "axios";
import dayjs from "dayjs";

import { useReactToPrint } from "react-to-print";
import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { Box, Grid, Stack, Button, Typography, Divider } from "@mui/material";
import { useSelector } from "react-redux";

// import { redirectUrl, commonBaseUrl } from 'src/config';

function MultiPrint({ rows, columns, data, title, grouped, EmployeeDetails }) {
  const componentRef = useRef();
  const navigate = useNavigate();

  const companyData = useSelector((state) => state.common.companyInfo);
  const logo = companyData.logo ? JSON.parse(companyData.logo).img : null;

  // const total = rows?.reduce((sum, row) => sum + row?.Qty, 0);
  // const totalAmount = rows?.reduce((sum, row) => sum + row?.Total, 0);

  // const companyDetails = async () => {
  //   try {
  //     const response = await axios.get(commonBaseUrl + companyDetailsApi, {
  //       withCredentials: true,
  //     });
  //     if (response.data) {
  //       setCompanyData(response.data[0]);
  //       setLogo(JSON.parse(response.data[0].logo).img);
  //     }
  //   } catch (err) {
  //     if (err?.response?.status === 403 || err?.response?.status === 401) {
  //       window.location.href = redirectUrl;
  //     }
  //   }
  // };

  // useEffect(() => {
  //   companyDetails();
  // }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getCellValue = (row, column) => {
    if (column.field === "conditionalField") {
      switch (row.typ) {
        case "TKT":
          return row.route;
        case "VS":
        case "CS":
        case "OS":
          return row.service;
        case "HS":
          return `${row.hotel} / ${row.nights} NTS`;
        default:
          return "";
      }
    }
    return row[column.field];
  };

  const renderMetaInfo = () => (
    <Stack direction="row" gap={2} flexWrap="wrap" my={2}>
      {data?.branch && (
        <Box>
          <Typography variant="body2">Branch: {data.branch.name}</Typography>
        </Box>
      )}
      {data?.type && (
        <Box>
          <Typography variant="body2">Type: {data.type}</Typography>
        </Box>
      )}
      {data?.saleType && (
        <Box>
          <Typography variant="body2">Sales: {data.saleType}</Typography>
        </Box>
      )}
      {data?.dom_inter && (
        <Box>
          <Typography variant="body2">D/I: {data.dom_inter}</Typography>
        </Box>
      )}
      {data?.airlines && (
        <Box>
          <Typography variant="body2">Airline: {data.airlines.name}</Typography>
        </Box>
      )}
      {data?.customer && (
        <Box>
          <Typography variant="body2">
            Customer: {data.customer.label}
          </Typography>
        </Box>
      )}
      {data?.supplier && (
        <Box>
          <Typography variant="body2">
            Supplier: {data.supplier.label}
          </Typography>
        </Box>
      )}
      {data?.staff && (
        <Box>
          <Typography variant="body2">Staff: {data.staff.label}</Typography>
        </Box>
      )}
      {data?.toDate && data?.fromDate && (
        <Box>
          <Typography variant="body2">
            Date: {dayjs(data.fromDate.$d).format("DD-MM-YYYY")} to{" "}
            {dayjs(data.toDate.$d).format("DD-MM-YYYY")}
          </Typography>
        </Box>
      )}
    </Stack>
  );

  const renderTable = (rowData = [], key) => {
    if (!Array.isArray(rowData)) {
      console.error("Invalid rowData passed to renderTable:", rowData);
      return null;
    }

    const saleRows = rowData;
    const total = saleRows.reduce((sum, row) => sum + row?.Qty, 0);
    const totalAmount = saleRows.reduce((sum, row) => sum + row?.Total, 0);

    // Calculate sale totals
    // const saleTotals = {};
    // columns.forEach((column) => {
    //   if (column.type === 'number') {
    //     saleTotals[column.field] = saleRows.reduce((sum, row) => {
    //       const value = getCellValue(row, column);
    //       return sum + (typeof value === 'number' ? value : 0);
    //     }, 0);
    //   }
    // });

    return (
      <Box
        key={key}
        // ref={componentRef}
        sx={{ width: "100%", px: 1, py: 1, pageBreakBefore: "always" }}
        className="reportPrintTable"
      >
        {/* Header Section */}
        <Grid container justifyContent="center" alignItems="center">
          <Grid item sm={1} textAlign="center">
            {logo ? (
              <img
                height="auto"
                width="100"
                src={logo}
                style={{ background: "white" }}
                alt=""
              />
            ) : (
              <div style={{ height: "100px", width: "100px" }} />
            )}
          </Grid>
          <Grid item sm={10} textAlign="center">
            <Typography
              variant="h5"
              sx={{ textTransform: "capitalize", m: 0 }}
              gutterBottom
            >
              {companyData?.Name}
            </Typography>
            {title && (
              <Typography variant="h6" gutterBottom sx={{ m: 0 }}>
                {title}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Typography
          variant="subtitle2"
          sx={{ fontWeight: "bold", textTransform: "uppercase" }}
        >
          {EmployeeDetails?.label}
        </Typography>
        {renderMetaInfo()}

        <Table sx={{ width: "100%" }} size="small">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.field}
                  sx={{
                    fontSize: "10px",
                    p: 0.5,
                    backgroundColor: "#673ab7",
                    color: "#FFF",
                    fontWeight: "bold",
                    border: "1px solid #673ab7",
                  }}
                >
                  {column.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          {/* Sale Rows */}
          <TableBody>
            {saleRows.map((row, index) => (
              <TableRow key={row.id}>
                {columns.map((column) => (
                  <TableCell
                    key={column.field}
                    sx={{
                      fontSize: "10px",
                      p: 0.5,
                      border: "0.5px solid black",
                    }}
                  >
                    {column.field === "uniq"
                      ? index + 1
                      : getCellValue(row, column)}
                  </TableCell>
                ))}
              </TableRow>
            ))}

            {/* Sale Total */}
            {/* <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.field}
                  sx={{ fontWeight: 'bold', fontSize: '10px', py: 0.3, px: 0.3 }}
                >
                  {column.type === 'number' ? saleTotals[column.field]?.toFixed(2) : ''}
                </TableCell>
              ))}
            </TableRow> */}
          </TableBody>
          <TableRow>
            <TableCell
              sx={{ bgcolor: "#f0f0f0", p: 1, border: "1px solid #f0f0f0" }}
            />
            <TableCell
              sx={{ bgcolor: "#f0f0f0", p: 1, border: "1px solid #f0f0f0" }}
            />
            <TableCell
              sx={{
                bgcolor: "#f0f0f0",
                p: 1,
                border: "1px solid #f0f0f0",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              Total
            </TableCell>
            <TableCell
              sx={{
                bgcolor: "#f0f0f0",
                p: 1,
                border: "1px solid #f0f0f0",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {total}
            </TableCell>
            <TableCell
              sx={{
                bgcolor: "#f0f0f0",
                p: 1,
                border: "1px solid #f0f0f0",
              }}
            />
            <TableCell
              sx={{
                bgcolor: "#f0f0f0",
                p: 1,
                border: "1px solid #f0f0f0",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {totalAmount}
            </TableCell>
          </TableRow>
        </Table>
      </Box>
    );
  };

  return (
    <>
      <Button variant="contained" color="secondary" onClick={handlePrint}>
        Print
      </Button>
      {/* <Button variant="contained" onClick={handleExportCSV}>
          Export CSV
        </Button>
        <Button variant="contained" onClick={handleExportXLSX}>
          Export XLSX
        </Button>
        <Button variant="contained" onClick={handleExportXLS}>
          Export XLS
        </Button> */}

      <div style={{ display: "none" }}>
        <div ref={componentRef}>
          {Object.entries(rows).map(([groupName, rowData]) => (
            <Box key={groupName} sx={{ mb: 4 }}>
              {/* Group Title */}

              {/* Render Table */}
              {renderTable(rowData, groupName)}
            </Box>
          ))}
        </div>
      </div>
    </>
  );
}

export default MultiPrint;
